import { ClientConfigProductName } from '@frontend/vanilla/core';

import { allowedProductGuard, clientConfigAppGuard, productUnderMaintenanceGuard } from '../guards';
import { RoutesConfig } from './routes-config';

const routes: RoutesConfig = {
    routes: [
        {
            path: 'bingo',
            loadChildren: () => import('@frontend/bingo/entrypoint-lib').then((t) => t.BingoRoutesModule),
            canMatch: [allowedProductGuard, clientConfigAppGuard],
            canActivate: [productUnderMaintenanceGuard],
            data: { product: ClientConfigProductName.BINGO },
        },
    ],
};

export default routes;
